import { 
  COUPON_ACCESS, 
  ROLES_ACCESS, 
  DASHBOARD_ACCESS, 
  COMPANY_ACCESS, 
  MAIL_TEMPLATE_ACCESS, 
  COMPANY_REQUEST_ACCESS,
  USER_ACCESS
 } from "@/helpers/superAdminPermissionConstant";

export default [
  {
    title: "Dashboard",
    route: "super-admin-dashboard",
    icon: "PieChartIcon",
    gate: DASHBOARD_ACCESS,
  },
  {
    title: "Role & Permission",
    route: "super-admin-roles",
    icon: "ShieldIcon",
    gate: ROLES_ACCESS,
  },
  {
    title: "User",
    route: "super-admin-user",
    icon: "UsersIcon",
    gate: USER_ACCESS,
  },
  {
    title: "Company",
    route: "company-management",
    icon: "HomeIcon",
    gate: COMPANY_ACCESS
  },
  {
    title: "Company Request",
    route: "company-request",
    icon: "ClipboardIcon",
    gate: COMPANY_REQUEST_ACCESS
  },
  {
    title: "Mail Sending",
    route: "mail-sending",
    icon: "MailIcon",
    gate: MAIL_TEMPLATE_ACCESS,
  },
  {
    title: "Coupon",
    route: "coupon",
    icon: "MailIcon",
    gate: COUPON_ACCESS,
  },
];
